import { getCurrentPeriod, getPrevPeriod } from '@ligr/shared';
import { sportFactStatMap } from '@ligr/api-v2';
import { milestones } from './football/milestones';
export const isLive = (args) => getCurrentPeriod(args.matchSummary).status === 'live';
export const isBreak = (args) => getCurrentPeriod(args.matchSummary).status === 'break';
export const isPenaltyShootout = (args) => getCurrentPeriod(args.matchSummary).shootout;
export const isOvertime = (args) => getCurrentPeriod(args.matchSummary).shootout;
export const isInjuryTime = (args) => args.clockData.injuryClock;
export const isPreOvertimeBreak = (args) => getCurrentPeriod(args.matchSummary).preOvertimeBreak;
export const hasTeamData = (args) => args.fact.teamId;
export const hasPlayerData = (args) => args.fact.teamId;
export const hasStartingLineupHomeTeam = (args) => args.fact.teamId;
export const hasStartingLineupAwayTeam = (args) => args.fact.teamId;
export const hasStartingLineupBothTeam = (args) => hasStartingLineupHomeTeam(args) && hasStartingLineupAwayTeam(args);
export const isLessThanXSecondsTillScheduledStart = (seconds) => (args) => args.clockData.expectedSecondsTillStart < seconds;
export const isPregame = ({ matchSummary }) => getCurrentPeriod(matchSummary).pregame;
export const isPostgame = ({ matchSummary }) => getCurrentPeriod(matchSummary).matchFinished;
export const aboutToStart = ({ matchSummary }) => { var _a; return (_a = getCurrentPeriod(matchSummary)) === null || _a === void 0 ? void 0 : _a.aboutToStart; };
export const playersEntered = ({ matchSummary }) => { var _a; return (_a = getCurrentPeriod(matchSummary)) === null || _a === void 0 ? void 0 : _a.playersEntered; };
export const isFactType = (type) => (fact) => fact.name === type;
export const moreThanOneLivePeriodPlayed = (args) => {
    return args.matchSummary.periods.filter(({ started, status }) => status === 'live' && started).length > 1;
};
export const atLeastOneLivePeriodStarted = (args) => {
    return args.matchSummary.periods.filter(({ started, status }) => status === 'live' && started).length > 0;
};
export const isNotMinimumCoverage = (args) => {
    return args.match.config.dataCoverage.stats !== 'minimum';
};
export const prevPeriodNotShootout = (args) => {
    var _a;
    return !((_a = getPrevPeriod(args.matchSummary)) === null || _a === void 0 ? void 0 : _a.shootout);
};
export const screenNotEmpty = (args) => {
    return Object.keys(args.desiredState).length;
};
export const liveAndNotWaitingPriorityOne = (args) => {
    const live = isLive(args);
    if (!live) {
        return false;
    }
    const sequenceQueue = args.sequenceQueue;
    if (!(sequenceQueue === null || sequenceQueue === void 0 ? void 0 : sequenceQueue.length)) {
        return true;
    }
    const topPriority = sequenceQueue[sequenceQueue.length - 1].priority;
    if (topPriority <= 3) {
        return false;
    }
    return true;
};
export const playerStatAggregate = (statKey, fact, period, args) => {
    var _a, _b, _c, _d, _e;
    if (period === 'total') {
        return ((_a = args.matchSummary.matchStats.players.find(({ playerId }) => playerId === fact.playerId)) === null || _a === void 0 ? void 0 : _a.stats)[statKey];
    }
    return ((_e = (_d = (_c = (_b = args.matchSummary.matchStats) === null || _b === void 0 ? void 0 : _b.periods) === null || _c === void 0 ? void 0 : _c.find(({ period: code }) => period === code)) === null || _d === void 0 ? void 0 : _d.players.find(({ playerId }) => playerId === fact.playerId)) === null || _e === void 0 ? void 0 : _e.stats)[statKey];
};
export const teamStatAggregate = (statKey, teamId, period, args) => {
    var _a;
    const teamType = args.match.homeTeam.id === teamId ? 'home' : 'away';
    if (period === 'total') {
        return args.matchSummary.matchStats[teamType][statKey];
    }
    return ((_a = args.matchSummary.matchStats) === null || _a === void 0 ? void 0 : _a.periods.find(({ period: code }) => period === code))[teamType][statKey];
};
export const isPlayerMilestone = (args) => {
    var _a, _b, _c;
    const playerId = (_a = args.fact) === null || _a === void 0 ? void 0 : _a.playerId;
    if (playerId) {
        const playerTotal = playerStatAggregate(
        // @ts-ignore
        sportFactStatMap[args.match.sportName][args.fact.name], args.fact, 'total', args);
        if (playerTotal && milestones[(_b = args.fact) === null || _b === void 0 ? void 0 : _b.name].player) {
            return [
                !(playerTotal % milestones[(_c = args.fact) === null || _c === void 0 ? void 0 : _c.name].player),
                Object.assign({ teamId: args.fact.teamId, playerId }, milestones[args.fact.name].data)
            ];
        }
    }
    return [false];
};
export const isTeamMilestone = (args) => {
    var _a, _b, _c, _d;
    const teamId = (_a = args.fact) === null || _a === void 0 ? void 0 : _a.teamId;
    if (teamId) {
        const usedStat = (((_b = milestones[args.fact.name]) === null || _b === void 0 ? void 0 : _b.stat) ||
            // @ts-ignore
            sportFactStatMap[args.match.sportName][args.fact.name]);
        const teamTotal = teamStatAggregate(usedStat, teamId, 'total', args);
        if (teamTotal && ((_d = milestones[(_c = args.fact) === null || _c === void 0 ? void 0 : _c.name]) === null || _d === void 0 ? void 0 : _d.team)) {
            return [
                !(teamTotal % milestones[args.fact.name].team),
                {
                    teamId,
                    primaryStatName: usedStat
                }
            ];
        }
    }
    return [false];
};
export const isTeamComparisonMilestone = (args) => {
    var _a;
    const usedStat = (((_a = milestones[args.fact.name]) === null || _a === void 0 ? void 0 : _a.stat) ||
        // @ts-ignore
        sportFactStatMap[args.match.sportName][args.fact.name]);
    const homeTotal = teamStatAggregate(usedStat, args.match.homeTeam.id, 'total', args);
    const awayTotal = teamStatAggregate(usedStat, args.match.awayTeam.id, 'total', args);
    const total = (homeTotal + awayTotal);
    if (milestones[args.fact.name]) {
        return [
            !!(milestones[args.fact.name].team && !(total % Math.ceil(milestones[args.fact.name].team * 1.5))),
            {
                period: 'total',
                statName: usedStat
            }
        ];
    }
    return [false];
};
//# sourceMappingURL=statements.js.map